module.exports = __webpack_public_path__ + "static/media/banner-img-pound-symbol.c2b23b66.png";